import { render, staticRenderFns } from "./NewsletterDialog.vue?vue&type=template&id=b8a17c04"
import script from "./NewsletterDialog.vue?vue&type=script&lang=js"
export * from "./NewsletterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports